/* eslint-disable max-len */
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  beforeSend: (event) => {
    return event;
  },
  dsn: SENTRY_DSN || 'https://1a360e6f59fa44acb7efea3cc91f4c4f@o49094.ingest.sentry.io/5880283',
  environment: process.env.APP_ENV,
  // Adjust this value in production, or use tracesSampler for greater control
  sampleRate: 0.5,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  ignoreErrors: [
    'AbortError',
    'attempting to access detached ArrayBuffer',
    'Cannot perform Construct on a detached ArrayBuffer',
    'Fullscreen request denied',
    'fullscreen error',
    'Network Error',
    'Non-Error promise rejection captured with value',
    'NotAllowedError: play() can only be initiated by a user gesture.',
    'NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
    'NotSupportedError: The element has no supported sources',
    'NotSupportedError: The operation is not supported',
    'ResizeObserver loop completed with undelivered notifications',
    'The object is in an invalid state.',
    'The operation is not supported',
    'The play method is not allowed by the user agent or the platform in the current context',
    'The request is not allowed by the user agent or the platform in the current context',
    'The video element does not have a video track or it has not detected a video track yet',
    'The video element is processing a Picture-in-Picture request',
    'timeout exceeded',
  ],
});
